<template>
  <div>
    <h1 class="page-header">{{ $t('infoinquiry.infoinquiry') }}</h1>
    <div class="row">
      <div class="col-lg-4 col-md-5 col-sm-12">
        <ts-card>
          <ts-card-wrapper>
            <div class="form-group">
              <label>{{ $t('infoinquiry.nameKH') }} </label>
              <div class="row">
                <div class="col-md-6">
                  <input
                    ref="first_name_kh"
                    type="text"
                    v-model="model.first_name_kh"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('first_name_kh') }"
                    :placeholder="$t('infoinquiry.surname')"
                  />
                  <div
                    class="invalid-feedback"
                    v-if="errors.has('first_name_kh')"
                  >
                    {{ errors.first('first_name_kh') }}
                  </div>
                </div>
                <div class="col-md-6">
                  <input
                    type="text"
                    v-model="model.last_name_kh"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('last_name_kh') }"
                    :placeholder="$t('infoinquiry.name')"
                  />
                  <div
                    class="invalid-feedback"
                    v-if="errors.has('last_name_kh')"
                  >
                    {{ errors.first('last_name_kh') }}
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group">
              <label class="control-label required"
                >{{ $t('infoinquiry.nameEN') }}
              </label>
              <div class="row">
                <div class="col-md-6">
                  <input
                    type="text"
                    v-model="model.first_name_en"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('first_name_en') }"
                    :placeholder="$t('infoinquiry.surname')"
                  />
                  <div
                    class="invalid-feedback"
                    v-if="errors.has('first_name_en')"
                  >
                    {{ errors.first('first_name_en') }}
                  </div>
                </div>
                <div class="col-md-6">
                  <input
                    type="text"
                    v-model="model.last_name_en"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('last_name_en') }"
                    :placeholder="$t('infoinquiry.name')"
                  />
                  <div
                    class="invalid-feedback"
                    v-if="errors.has('last_name_en')"
                  >
                    {{ errors.first('last_name_en') }}
                  </div>
                </div>
              </div>
              <div class="invalid-feedback" v-if="errors.has('last_name_en')">
                {{ errors.first('last_name_en') }}
              </div>
            </div>
            <div class="form-group">
              <label class="required">{{ $t('infoinquiry.gender') }} </label>
              <select
                class="form-control"
                v-model="model.gender"
                :class="{ 'is-invalid': errors.has('gender') }"
              >
                <option value="" disabled selected style="display: none">
                  {{ $t('select') }}
                </option>
                <option
                  v-for="(gender, index) in genders"
                  :key="index"
                  :value="gender.value"
                >
                  {{ gender.description }}
                </option>
              </select>
              <div class="invalid-feedback" v-if="errors.has('gender')">
                {{ errors.first('gender') }}
              </div>
            </div>
            <div class="form-group">
              <label>{{ $t('infoinquiry.dateofBirth') }}</label>
              <ts-date-picker-input v-model="model.date_of_birth" />
              <div v-if="errors.has('date_of_birth')" class="validate">
                {{ errors.first('date_of_birth') }}
              </div>
            </div>
            <div class="form-group">
              <label>{{ $t('infoinquiry.nationality') }} </label>
              <ts-search-select
                v-model.number="model.na_id"
                :options="nationalityOptions"
              ></ts-search-select>
              <div v-if="errors.has('na_id')" class="validate">
                {{ errors.first('na_id') }}
              </div>
            </div>
            <div class="form-group">
              <div class="row">
                <div class="col-md-6">
                  <label>{{ $t('infoinquiry.educationLevel') }} </label>
                  <input
                    type="text"
                    v-model="model.education_level"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('education_level') }"
                    :placeholder="$t('infoinquiry.entereDucationLevel')"
                  />
                  <div
                    class="invalid-feedback"
                    v-if="errors.has('education_level')"
                  >
                    {{ errors.first('education_level') }}
                  </div>
                </div>
                <div class="col-md-6">
                  <label
                    >{{ $t('infoinquiry.fromSchool') }}
                  </label>
                  <div class="ts-w-full" ref="mySearchDiv">
                    <div class="ts-relative demo-spin-article">
                      <input
                        type="text"
                        v-model="model.from_school"
                        class="form-control"
                        :class="{ 'is-invalid': errors.has('from_school') }"
                        :placeholder="$t('infoinquiry.fromSchool')"
                      />
                      <a-list
                        v-if="visibleSearch"
                        bordered
                        class="search-dropdown"
                      >
                        <a-list-item
                          v-for="(item, index) in fromSchoolsOptions"
                          :key="index"
                          class="ts-cursor-pointer hover:ts-bg-gray-300 ts-w-full"
                        >
                          <div
                            class="ts-text-left ts-w-full"
                            @click="model.from_school = item"
                          >
                            {{ item }}
                          </div>
                        </a-list-item>
                      </a-list>
                    </div>
                  </div>
                  <div v-if="errors.has('from_school')" class="validate">
                    {{ errors.first('from_school') }}
                  </div>
                </div>
              </div>
            </div>
            <h1 class="section-divider mt-3">
              {{ $t('infoinquiry.academic') }}
            </h1>
            <div class="form-group">
              <label class="control-label required"
                >{{ $t('infoinquiry.mainProgram') }}
              </label>
              <ts-search-select
                v-model.number="model.acp_id"
                @change="mainProgramChange(model.acp_id)"
                :options="mainProgramOptions"
                @input="model.acps_id = ''"
              ></ts-search-select>
              <div class="validate" v-if="errors.has('acps_id')">
                {{ errors.first('acps_id') }}
              </div>
            </div>
            <div class="form-group">
              <label class="control-label"
                >{{ $t('infoinquiry.subProgram') }}
                <span class="text-danger">*</span>
                <i
                  v-if="sub_programs.length == 0 && model.acps_id !== ''"
                  class="fas fa-spinner fa-pulse label-loading"
                ></i>
              </label>
              <select
                :readonly="sub_programs.length == 0"
                v-model="model.acps_id"
                class="form-control"
                :class="{ 'is-invalid': errors.has('acps_id') }"
               @change="getCommune(model.acps_id)"
              >
                <option value="" disabled selected style="display: none">
                  {{ $t('Select') }}
                </option>
                <option
                  v-for="(sub_program, index) in sub_programs"
                  :key="index"
                  :value="sub_program.acps_id"
                >
                  {{ sub_program.acps_name_foreign }}
                </option>
              </select>
              <div class="invalid-feedback" v-if="errors.has('acps_id')">
                {{ errors.first('acps_id') }}
              </div>
            </div>
            <div class="form-group">
              <label class="control-label required"
                >{{ $t('infoinquiry.studyTime') }}
              </label>
              <select
                class="form-control"
                v-model.number="model.ac_st_id"
                :class="{ 'is-invalid': errors.has('ac_st_id') }"
              >
                <option value="0" disabled selected style="display: none">
                  --All--
                </option>
                <option
                  v-for="(study_time, index) in study_times"
                  :key="index"
                  :value="study_time.ac_st_id"
                >
                  {{ study_time.study_time }} | {{ study_time.session }}
                </option>
              </select>
              <div class="invalid-feedback" v-if="errors.has('ac_st_id')">
                {{ errors.first('ac_st_id') }}
              </div>
            </div>
            <div class="form-group">
              <div class="form-group">
                <label class="control-label">{{
                  $t('infoinquiry.studyTimeStatus')
                }}</label>
                <select class="form-control" v-model="model.study_time_status">
                  <option value="" disabled selected style="display: none">
                    {{ $t('select') }}
                  </option>
                  <option
                    v-for="(sta, index) in status"
                    :key="index"
                    :value="sta.value"
                  >
                    {{ sta.description }}
                  </option>
                </select>
              </div>
            </div>
            <div class="form-group">
              <label class="control-label">{{
                $t('infoinquiry.remark')
              }}</label>
              <input
                type="text"
                class="form-control"
                :class="{ 'is-invalid': errors.has('remarks') }"
                v-model="model.remarks"
                :placeholder="$t('infoinquiry.enterRemarks')"
              />
              <div class="invalid-feedback" v-if="errors.has('remarks')">
                {{ errors.first('remarks') }}
              </div>
            </div>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-lg-8 col-md-7 col-sm-12">
        <ts-card>
          <ts-card-wrapper>
            <form class="form-horizontal">
              <h1 class="section-divider">{{ $t('infoinquiry.contact') }}</h1>
              <div class="row mb-3">
                <div class="col-sm-12 col-lg-6 col-md-12">
                  <div class="form-group row">
                    <label
                      class="col-md-4 form-col-label control-label required"
                    >
                      {{ $t('infoinquiry.guardian') }}
                    </label>
                    <div class="col-md-7">
                      <input
                        type="text"
                        class="form-control"
                        :class="{ 'is-invalid': errors.has('contact_name') }"
                        v-model="model.contact_name"
                        :placeholder="$t('infoinquiry.enterGuardianname')"
                      />
                      <div
                        class="invalid-feedback"
                        v-if="errors.has('contact_name')"
                      >
                        {{ errors.first('contact_name') }}
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label
                      class="col-md-4 form-col-label control-label required"
                    >
                      {{ $t('infoinquiry.relationship') }}</label
                    >
                    <div class="col-md-7">
                      <select
                        class="form-control"
                        v-model="model.relationship"
                        :class="{ 'is-invalid': errors.has('relationship') }"
                      >
                        <option
                          value=""
                          disabled
                          selected
                          style="display: none"
                        >
                          {{ $t('select') }}
                        </option>
                        <option
                          v-for="(relationship, index) in relationships"
                          :key="index"
                          :value="relationship.value"
                        >
                          {{ relationship.description }}
                        </option>
                      </select>
                      <div
                        class="invalid-feedback"
                        v-if="errors.has('relationship')"
                      >
                        {{ errors.first('relationship') }}
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label
                      class="col-md-4 form-col-label control-label required"
                    >
                      {{ $t('infoinquiry.contactNumber') }}</label
                    >
                    <div class="col-md-7">
                      <input
                        type="text"
                        class="form-control"
                        :class="{ 'is-invalid': errors.has('contact_number') }"
                        v-model="model.contact_number"
                        :placeholder="$t('infoinquiry.enterContactNumber')"
                      />
                      <div
                        class="invalid-feedback"
                        v-if="errors.has('contact_number')"
                      >
                        {{ errors.first('contact_number') }}
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-4 form-col-label control-label">
                      {{ $t('infoinquiry.email') }}</label
                    >
                    <div class="col-md-7">
                      <input
                        type="email"
                        class="form-control"
                        :class="{ 'is-invalid': errors.has('email') }"
                        v-model="model.email"
                        ref="email"
                        :placeholder="$t('infoinquiry.enterEmail')"
                      />
                      <div class="invalid-feedback" v-if="errors.has('email')">
                        {{ errors.first('email') }}
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-4 form-col-label control-label">
                      {{ $t('infoinquiry.facebook') }}</label
                    >
                    <div class="col-md-7">
                      <input
                        type="text"
                        class="form-control"
                        :class="{ 'is-invalid': errors.has('facebook') }"
                        v-model="model.facebook"
                        :placeholder="$t('infoinquiry.enterfacebookname')"
                      />
                      <div
                        class="invalid-feedback"
                        v-if="errors.has('facebook')"
                      >
                        {{ errors.first('facebook') }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 col-lg-6 col-md-12">
                  <div class="form-group row">
                    <label class="col-md-4 form-col-label control-label">
                      {{ $t('infoinquiry.linkedIn') }}
                    </label>
                    <div class="col-md-7">
                      <input
                        type="text"
                        v-model="model.linkin"
                        class="form-control"
                        :class="{ 'is-invalid': errors.has('linkin') }"
                        :placeholder="$t('infoinquiry.enterlinkedInname')"
                      />
                      <div class="invalid-feedback" v-if="errors.has('linkin')">
                        {{ errors.first('linkin') }}
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-4 form-col-label control-label">
                      {{ errors.first('telegram') }}
                    </label>
                    <div class="col-md-7">
                      <input
                        type="text"
                        v-model="model.telegram"
                        class="form-control"
                        :class="{ 'is-invalid': errors.has('telegram') }"
                        :placeholder="$t('infoinquiry.entertelegramcontact')"
                      />
                      <div
                        class="invalid-feedback"
                        v-if="errors.has('telegram')"
                      >
                        {{ errors.first('telegram') }}
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-4 form-col-label control-label">
                      {{ $t('infoinquiry.line') }}
                    </label>
                    <div class="col-md-7">
                      <input
                        type="text"
                        v-model="model.line"
                        class="form-control"
                        :class="{ 'is-invalid': errors.has('line') }"
                        :placeholder="$t('infoinquiry.enterlinename')"
                      />
                      <div class="invalid-feedback" v-if="errors.has('line')">
                        {{ errors.first('line') }}
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-4 form-col-label control-label">
                      {{ $t('infoinquiry.weChat') }}
                    </label>
                    <div class="col-md-7">
                      <input
                        type="text"
                        v-model="model.we_chat"
                        class="form-control"
                        :class="{ 'is-invalid': errors.has('we_chat') }"
                        :placeholder="$t('infoinquiry.enterwechatname')"
                      />
                      <div
                        class="invalid-feedback"
                        v-if="errors.has('we_chat')"
                      >
                        {{ errors.first('we_chat') }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <h1 class="section-divider">{{ $t('infoinquiry.address') }}</h1>
              <div class="row mb-3">
                <div class="col-sm-12 col-lg-6 col-md-12">
                  <div class="form-group row">
                    <label
                      class="col-md-4 form-col-label control-label text-right"
                    >
                      {{ $t('infoinquiry.province') }}
                    </label>
                    <div class="col-md-7">
                      <a-select
                        v-model="model.province_code"
                        @change="onChangeProvince"
                        :allowClear="true"
                        showSearch
                        :filterOption="
                              (input, option) =>
                                option.componentOptions.children[0].text
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                            "
                      >
                        <a-select-option
                          v-for="(province, index) in provinces"
                          :key="index"
                          :value="province.province_code"
                        >
                          {{ province.province_name }} |
                          {{ province.province_name_native }}
                        </a-select-option>
                      </a-select>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label
                      class="col-md-4 form-col-label control-label text-right"
                    >
                      {{ $t('infoinquiry.district') }}
                    </label>
                    <div class="col-md-7">
                      <a-select
                        :readonly="districts.length == 0"
                        v-model="model.district_code"
                        @change="onChangeDistrict"
                        :allowClear="true"
                        showSearch
                        :filterOption="
                              (input, option) =>
                                option.componentOptions.children[0].text
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                            "
                      >
                        <a-select-option
                          v-for="(district, index) in districts"
                          :key="index"
                          :value="district.district_code"
                        >
                          {{ district.district_name }} |
                          {{ district.district_name_native }}
                        </a-select-option>
                      </a-select>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label
                      class="col-md-4 form-col-label control-label text-right"
                    >
                      {{ $t('infoinquiry.commune') }}
                    </label>
                    <div class="col-md-7">
                      <a-select
                        :readonly="communes.length == 0"
                        v-model="model.commune_code"
                        @change="onChangeCommune"
                        :allowClear="true"
                        showSearch
                        :filterOption="
                              (input, option) =>
                                option.componentOptions.children[0].text
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                            "
                      >
                        <a-select-option
                          v-for="(commune, index) in communes"
                          :key="index"
                          :value="commune.commune_code"
                        >
                          {{ commune.commune_name }} |
                          {{ commune.commune_name_native }}
                        </a-select-option>
                      </a-select>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label
                      class="col-md-4 form-col-label control-label text-right"
                    >
                      {{ $t('infoinquiry.village') }}
                    </label>
                    <div class="col-md-7">
                      <a-select
                        :readonly="villages.length == 0"
                        v-model="model.village_code"
                        :allowClear="true"
                        showSearch
                        :filterOption="
                              (input, option) =>
                                option.componentOptions.children[0].text
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                            "
                      >
                        <a-select-option
                          v-for="(village, index) in villages"
                          :key="index"
                          :value="village.village_code"
                        >
                          {{ village.village_name }} |
                          {{ village.village_name_native }}
                        </a-select-option>
                      </a-select>
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 col-lg-6 col-md-12">
                  <div class="form-group row">
                    <label class="col-md-4 form-col-label control-label">
                      {{ $t('infoinquiry.houseNo') }}
                    </label>
                    <div class="col-md-7">
                      <input
                        type="text"
                        v-model="model.house"
                        class="form-control"
                        :class="{ 'is-invalid': errors.has('house') }"
                        :placeholder="$t('infoinquiry.enterhouseNo')"
                      />
                      <div class="invalid-feedback" v-if="errors.has('house')">
                        {{ errors.first('house') }}
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-4 form-col-label control-label">
                      {{ $t('infoinquiry.streetNo') }}
                    </label>
                    <div class="col-md-7">
                      <input
                        type="text"
                        v-model="model.street"
                        class="form-control"
                        :class="{ 'is-invalid': errors.has('street') }"
                        :placeholder="$t('infoinquiry.enterstreetNo')"
                      />
                      <div class="invalid-feedback" v-if="errors.has('street')">
                        {{ errors.first('street') }}
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-md-4 form-col-label control-label">
                      {{ $t('infoinquiry.placeOfBirth') }}
                    </label>
                    <div class="col-md-7">
                      <textarea
                        rows="4"
                        v-model="model.place_of_birth"
                        class="form-control"
                        :class="{ 'is-invalid': errors.has('place_of_birth') }"
                        :placeholder="$t('infoinquiry.enterplaceofbirth')"
                      >
                      </textarea>
                      <div
                        class="invalid-feedback"
                        v-if="errors.has('place_of_birth')"
                      >
                        {{ errors.first('place_of_birth') }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <label class="required ts-flex-no-wrap">
                <label class="section-divider">{{ $t('infoinquiry.sourceofInquiry') }}</label>
              </label>
              <div class="row mb-3">
                <div class="col-sm-12 col-lg-6 col-md-12">
                  <div class="row form-group m-b-10">
                    <label
                      class="col-md-4 form-col-label control-label"
                    ></label>
                    <div class="col-md-3">
                      <ts-checkbox v-model="model.leaflet">{{
                        $t('infoinquiry.leaflet')
                      }}</ts-checkbox>
                    </div>
                    <div class="col-md-4">
                      <ts-checkbox v-model="model.newspaper">{{
                        $t('infoinquiry.newspaper')
                      }}</ts-checkbox>
                    </div>
                  </div>
                  <div class="row form-group m-b-10">
                    <label
                      class="col-md-4 form-col-label control-label"
                    ></label>
                    <div class="col-md-3">
                      <ts-checkbox v-model="model.friend"
                        >{{ $t('infoinquiry.friend') }}
                      </ts-checkbox>
                    </div>
                    <div class="col-md-4">
                      <ts-checkbox v-model="model.facebooks">{{
                        $t('infoinquiry.facebook')
                      }}</ts-checkbox>
                    </div>
                  </div>
                  <div class="row form-group m-b-10">
                    <label
                      class="col-md-4 form-col-label control-label"
                    ></label>
                    <div class="col-md-3">
                      <ts-checkbox v-model="model.walk_in">{{
                        $t('infoinquiry.walkin')
                      }}</ts-checkbox>
                    </div>
                    <div class="col-md-4">
                      <ts-checkbox v-model="model.refferal">{{
                        $t('infoinquiry.refferal')
                      }}</ts-checkbox>
                    </div>
                  </div>
                  <div class="row form-group m-b-10">
                    <label
                      class="col-md-4 form-col-label control-label"
                    ></label>
                    <div class="col-md-7">
                      <ts-checkbox v-model="model.other">{{
                        $t('infoinquiry.otherPleaseSpecify')
                      }}</ts-checkbox>
                    </div>
                  </div>
                  <div class="row form-group m-b-10" v-if="model.other">
                    <label
                      class="col-md-4 form-col-label control-label"
                    ></label>
                    <div class="col-md-7">
                      <input
                        type="text"
                        v-model="model.other_comment"
                        class="form-control"
                        :class="{ 'is-invalid': errors.has('other_comment') }"
                        :placeholder="$t('infoinquiry.entercommenthere')"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 col-lg-6 col-md-12">
                  <div class="row form-group m-b-10">
                    <label
                      class="col-md-4 form-col-label control-label"
                    ></label>
                    <div class="col-md-3">
                      <ts-checkbox v-model="model.tv">{{
                        $t('infoinquiry.tv')
                      }}</ts-checkbox>
                    </div>
                    <div class="col-md-4">
                      <ts-checkbox v-model="model.accross_the_road">{{
                        $t('infoinquiry.accrosstheRoad')
                      }}</ts-checkbox>
                    </div>
                  </div>
                  <div class="row form-group m-b-10">
                    <label
                      class="col-md-4 form-col-label control-label"
                    ></label>
                    <div class="col-md-3">
                      <ts-checkbox v-model="model.relative">{{
                        $t('infoinquiry.relative')
                      }}</ts-checkbox>
                    </div>
                    <div class="col-md-4">
                      <ts-checkbox v-model="model.radio">{{
                        $t('infoinquiry.Radio')
                      }}</ts-checkbox>
                    </div>
                  </div>
                  <div class="row form-group m-b-10">
                    <label
                      class="col-md-4 form-col-label control-label"
                    ></label>
                    <div class="col-md-7">
                      <ts-checkbox v-model="model.marketing_agent">{{
                        $t('infoinquiry.marketingAgent')
                      }}</ts-checkbox>
                    </div>
                  </div>
                </div>
                <div class="validate" v-if="errors.has('source_of_inquiry')">
                        {{ errors.first('source_of_inquiry') }}
                </div>
              </div>
              <div class="row">
                <div
                  class="col-sm-12 col-lg-12 col-md-12 text-right ts-flex ts-justify-items-end ts-justify-end"
                >
                  <div class="row mr-1">
                    <label class="col-md-4 form-col-label control-label">
                      {{ $t('infoinquiry.date') }}</label
                    >
                    <div class="col-md-8">
                      <ts-date-picker-input v-model="model.inquiry_date" />
                    </div>
                  </div>
                  <ts-button
                    color="primary"
                    :waiting="waiting"
                    @click.prevent="update"
                  >
                    {{ $t('update') }}
                  </ts-button>
                  <ts-button
                    class="ml-2"
                    @click.prevent="$router.push({ name: 'info-inquiry' })"
                    >{{ $t('Cancel') }}</ts-button
                  >
                </div>
              </div>
            </form>
          </ts-card-wrapper>
        </ts-card>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'
export default {
  name: 'info-inquiry-edit',
  data () {
    return {
      model: {
        inquiry_id: 0,
        last_name_kh: '',
        first_name_kh: '',
        last_name_en: '',
        first_name_en: '',
        gender: '',
        education_level: '',
        na_id: '',
        date_of_birth: '',
        place_of_birth: '',
        house: '',
        street: '',
        village_code: '',
        commune_code: '',
        district_code: '',
        province_code: '',
        country_id: '',
        acp_id: '',
        acps_id: '',
        contact_name: '',
        contact_number: '',
        email: '',
        relationship: '',
        ac_st_id: 0,
        facebook: '',
        linkin: '',
        telegram: '',
        line: '',
        we_chat: '',
        leaflet: false,
        newspaper: false,
        tv: false,
        accross_the_road: false,
        friend: false,
        facebooks: false,
        relative: false,
        marketing_agent: false,
        walk_in: false,
        refferal: false,
        radio: false,
        other: false,
        other_comment: '',
        remarks: '',
        inquiry_date: '',
        from_school: '',
        study_time_status:''
      },
      genders: [
        {
          value: 'M',
          description: 'Male'
        },
        {
          value: 'F',
          description: 'Female'
        }
      ],
      relationships: [
        {
          value: 'Father',
          description: 'Father'
        },
        {
          value: 'Mother',
          description: 'Mother'
        },
        {
          value: 'Other',
          description: 'Other'
        }
      ],
      status:[
         {
          value:'full day',
          description:'Full Day'
         },
         {
          value:'half day',
          description:'Half Day'
         }
      ],
      
      errors: new Errors(),
      waiting: false,
      waiting_save_add_new: false,
      main_program_change: false,
      province_change: false,
      district_change: false,
      commune_change: false,
      show_modal: false,
      visibleSearch: false,
      fromSchoolLoading: false
    }
  },
  mounted () {
    this.$refs.first_name_kh.focus()
    document.addEventListener('click', this.handleClickOutside)
  },
  created () {
    this.setEditData()
  },
  computed: {
    ...mapState('infoInquiry', [
      'found_data',
      'sub_programs',
      'study_times',
      'provinces',
      'districts',
      'communes',
      'villages'
    ]),
    fromSchoolsOptions () {
      if (!this.$store.state.infoInquiry.fromSchools) return []
      return this.$store.state.infoInquiry.fromSchools
        .map(el => el.from_school)
        .filter(c =>
          c.toLowerCase().includes(this.model.from_school.toLowerCase())
        )
        .slice(0, 400)
    },
    nationalityOptions () {
      return this.$store.state.infoInquiry.nationalities.map(el => ({
        value: el.id,
        text: el.nationality
      }))
    },
    mainProgramOptions () {
      return this.$store.state.infoInquiry.main_programs.map(el => ({
        value: el.acp_id,
        text: el.acp_name_foreign
      }))
    }
  },
  methods: {
    ...mapActions('infoInquiry', [
      'getSubProgram',
      'getDistrict',
      'getCommune',
      'getVillage'
    ]),
    handleClickOutside (event) {
      if (
        this.$refs.mySearchDiv &&
        !this.$refs.mySearchDiv.contains(event.target)
      ) {
        this.visibleSearch = false
      } else {
        this.visibleSearch = true
      }
    },
    async update () {
      this.errors = new Errors()
      this.waiting = true

      this.$store
        .dispatch('infoInquiry/update', this.model)
        .then(response => {
          this.waiting = false
          this.$toasted.success(response.message)
          this.$router.push({ name: 'info-inquiry' })
        })
        .catch(error => {
          this.waiting = false
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
    },
    onChangeProvince(province_code){
      this.model.district_code = ''
      this.model.commune_code = ''
      this.model.village_code = ''
      this.$store.dispatch('infoInquiry/getDistrict', province_code)
    },
    onChangeDistrict(district_code){
      this.model.commune_code = ''
      this.model.village_code = ''
      this.$store.dispatch('infoInquiry/getCommune', district_code)
    },
    onChangeCommune(commune_code){
      this.model.village_code = ''
      this.$store.dispatch('infoInquiry/getVillage', commune_code)
    },

    setEditData () {
      if (this.found_data === null || this.found_data === undefined) return

      this.model = Object.assign({}, this.found_data)
    }
  },
  watch: {
    'model.acp_id': function (value) {
      if (value) {
        this.getSubProgram(value)
      }
    },
    'model.province_code': function (value) {
      if (value) {
        this.getDistrict(value)
      }
    },
    'model.district_code': function (value) {
      if (value) {
        this.getCommune(value)
      }
    },
    'model.commune_code': function (value) {
      if (value) {
        this.getVillage(value)
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    if (_.isEmpty(to.params)) {
      this.$store.commit('infoInquiry/RESET_STATE')
      this.$store.commit('infoInquiry/SET_FOUND_DATA', {})
      this.$store.commit('infoInquiry/SET_NATIONALITIES', [])
      this.$store.commit('infoInquiry/SET_MAIN_PROGRAMS', [])
      this.$store.commit('infoInquiry/SET_SUB_PROGRAMS', [])
      this.$store.commit('infoInquiry/SET_STUDY_TIMES', [])
      this.$store.commit('infoInquiry/SET_PROVINCES', [])
      this.$store.commit('infoInquiry/SET_DISTRICTS', [])
      this.$store.commit('infoInquiry/SET_COMMUNES', [])
      this.$store.commit('infoInquiry/SET_VILLAGES', [])
    }
    next()
  }
}
</script>
<style lang="css" scoped>
.search-dropdown {
  position: absolute;
  will-change: top, left;
  transform-origin: center top;
  width: 100%;
  top: 32px;
  max-height: 200px;
  min-height: 30px;
  overflow: auto;
  padding: 5px 0;
  background-color: #fff;
  box-sizing: border-box;
  border-radius: 2px;
  box-shadow: 0 0 1px rgba(0, 0, 0, 0.2);
  z-index: 9999999 !important;
}
.ant-list-item {
  padding: 2px 7px;
}
</style>
